var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"locations"}},_vm._l((_vm.locations),function(location){return _c('LocationCard',{key:location.mId,attrs:{"location":location,"selectLocationMethod":_vm.setCurrentLocation}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }